import React from "react"

import { Tab } from "~components/Tabs"
import CodeBlock from "~components/CodeBlock"

/**
 * Shows a specific code sample for a programming language
 */
const CodeSample = ({ sample }) => (
  <Tab title={sample.language}>
    <CodeBlock language={sample.language} code={sample.code} />
  </Tab>
)

export default CodeSample
